/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 16:59:09
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 17:00:53
 */
export default {
	"common.no data": "无数据"
};
